import { Controller } from "@hotwired/stimulus"

// Toggles visibility of dependent form fields based on select value
// Usage: 
//   - Add data-controller="conditional-field" to form
//   - Add data-conditional-field-target="select" to select element
//   - Add data-conditional-field-target="field" data-show-when="value" to conditional fields
//   - Can have multiple data-show-when values separated by commas: data-show-when="value1,value2"
export default class extends Controller {
  static targets = ["select", "field"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selectedValue = this.selectTarget.value

    this.fieldTargets.forEach(el => {
      const showWhen = el.dataset.showWhen
      if (!showWhen) {
        el.style.display = 'none'
        return
      }
      
      // Support comma-separated values
      const showValues = showWhen.split(',').map(v => v.trim())
      const shouldShow = showValues.includes(selectedValue)
      el.style.display = shouldShow ? 'block' : 'none'
    })
  }
}
